/**
 * Created by adalto on 8/19/14.
 */


Monet.Format = Monet.Format || {};
Monet.Format.TIME_LENGTH = (function () {

    function TIME_LENGTH(value) {

        this.value = value;

        this.convertMillisecondsToHoursAndMinutes = function () {

            try {

                if (this.value > 0) {

                    var keyHourAbreviation = "Greenmile.UnitMetrics.hourAbreviation",
                        keyMinuteAbreviation = "Greenmile.UnitMetrics.minuteAbreviation",
                        seconds = Math.floor(this.value / 1000),
                        minutes = Math.floor(seconds / 60),
                        hour = Math.floor(minutes / 60),
                        hourAbreviation = Monet.I18n.getResourcesByKey(keyHourAbreviation),
                        minuteAbreviation = Monet.I18n.getResourcesByKey(keyMinuteAbreviation);

                    this.value = hour + hourAbreviation + " ";
                    this.value += minutes % 60 + minuteAbreviation + " ";
                }

            } catch (e) {

                var error = new Monet.Exception.ReturnError(this,
                    "Error on convert miliseconds on hour and minutes.");
                error.console();

            }

            return this;

        };

        this.toGrid = function () {
            return this.convertMillisecondsToHoursAndMinutes();
        };

        this.getValue = function () {
            if (!this.value) {
                this.value = "";
            }
            return this.value;
        };

    }

    return TIME_LENGTH;

}());